import { useEffect, useState } from "react";
import { useChatSocket } from "@/hooks/useChatSocket";
import {
  NOTIFICATION_PREFERENCES_CHANGED,
  NotificationPreference,
  staffNotificationPreferenceRepository,
} from "@/repository/staffNotificationPreferenceRepository";
import { localAuthRepository } from "@/repository/localAuthRepository";

export function useStaffNotificationPreferences() {
  const [preferences, setPreferences] = useState<
    NotificationPreference[] | null
  >(null);
  const staffId = localAuthRepository.getUserInfo()?.id;
  const { onStaffInboxChanged, readyRevision } = useChatSocket();
  useEffect(() => {
    let active = true;
    let revision = 0;
    setPreferences(null);
    const refresh = () => {
      const request = ++revision;
      void staffNotificationPreferenceRepository
        .get()
        .then((data) => {
          if (active && request === revision) setPreferences(data);
        })
        .catch(() => {});
    };
    refresh();
    const resume = () => {
      if (document.visibilityState === "visible") refresh();
    };
    const unsubscribe = onStaffInboxChanged((event) => {
      if (event.reason === "preferences-changed") refresh();
    });
    window.addEventListener(NOTIFICATION_PREFERENCES_CHANGED, refresh);
    window.addEventListener("focus", resume);
    window.addEventListener("online", resume);
    document.addEventListener("visibilitychange", resume);
    return () => {
      active = false;
      unsubscribe();
      window.removeEventListener(NOTIFICATION_PREFERENCES_CHANGED, refresh);
      window.removeEventListener("focus", resume);
      window.removeEventListener("online", resume);
      document.removeEventListener("visibilitychange", resume);
    };
  }, [staffId, onStaffInboxChanged, readyRevision]);
  return preferences;
}
